import { useMemo, useState, useSyncExternalStore } from "react";
import { connectWallet, subscribeWallets, supportsChains, walletsSnapshot, } from "./registry.js";
const SERVER_WALLETS = [];
const serverSnapshot = () => SERVER_WALLETS;
function walletId(wallet) {
    return `wallet-standard:${wallet.name}`;
}
function toLocalWallet(wallet) {
    return { id: walletId(wallet), name: wallet.name, icon: wallet.icon };
}
/**
 * Discovers injected Solana wallets for {@link useProviderPairing}'s `sources`.
 *
 * Solana extensions announce themselves through the Wallet Standard window events; this hook
 * lists the announcements and connects the one the user picks. It is discovery only: after
 * `onConnect` the app owns the wallet handle, its accounts, and its lifecycle.
 */
export function useWalletStandardSource({ chains, onConnect, onError, }) {
    const announced = useSyncExternalStore(subscribeWallets, walletsSnapshot, serverSnapshot);
    const [connectedId, setConnectedId] = useState();
    const chainKey = chains?.join(",") ?? "";
    const matching = useMemo(() => {
        const filter = chainKey ? chainKey.split(",") : undefined;
        return announced.filter((wallet) => supportsChains(wallet, filter));
    }, [announced, chainKey]);
    const wallets = useMemo(() => matching.map(toLocalWallet), [matching]);
    const connect = (wallet) => {
        const target = matching.find((candidate) => walletId(candidate) === wallet.id);
        if (!target)
            return;
        void connectWallet(target)
            .then(() => {
            setConnectedId(wallet.id);
            onConnect(target);
        })
            .catch((e) => onError?.(e instanceof Error ? e : new Error(String(e))));
    };
    return { wallets, connect, connected: connectedId !== undefined };
}
//# sourceMappingURL=index.js.map